var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-card",
    { staticClass: "TextCard" },
    [
      _c(
        "md-card-header",
        { staticClass: "TextCard__Wrapper" },
        [
          _c("md-card-header-text", { staticClass: "TextCard__Header" }, [
            _c(
              "div",
              { staticClass: "IconBox" },
              [
                _c(
                  "md-icon",
                  { staticClass: "IconBox__Icon" },
                  [_vm._t("recCard__Icon")],
                  2
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "md-title" }, [
              _c("h4", [_vm._t("recCard__Headline")], 2)
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("md-card-content", { staticClass: "TextCard__Content" }, [
        _c("div", [_vm._t("recCard__Content")], 2)
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-095daf04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-095daf04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/kirc/components/RecommendationCard.vue
// module id = null
// module chunks = 